<template>
    <section class="login">
		<van-popup v-model="isLoginModel" round position="bottom" :style="{ height: '98%' }" class="login_model" :close-on-click-overlay="false">
			<section class="login_box" v-if="type == 'login'">
				<div class="close_icon" @click="closeModel">
					<van-icon name="cross" />
				</div>
				<div class="login_icon">
					<img src="../../assets/img/login_icon.png">
				</div>
				<div class="form">
					<van-field v-model="params.phone" type="digit" placeholder="请输入手机号" @input="changePhone" maxlength="11" />
					<van-field v-model="params.smsCaptcha" type="digit" maxlength="7" placeholder="请输入验证码" @input="changeCode">
						<template #button>
							<p class="code" :class="{code_a: isCode}" @click="getCode" v-if="!isSend">获取验证码</p>
							<p class="code" v-else><van-count-down :time="time" format="ss" @finish="timeFinish" ref="time" />s后重发</p>
						</template>
					</van-field>
				</div>
				<div class="desc">
					<div @click="agreeFn">
						<img src="../../assets/img/tongyi.png" v-if="!isAgree">
						<img src="../../assets/img/tongyi_a.png" v-else>
					</div>
					<p>同意并接受<span @click="lookFn('yinsi')">《隐私协议》、</span><span @click="lookFn('yonghu')">《用户协议》</span>及<span @click="lookFn('kehu')">《展业经理公约》</span></p>
				</div>
				<div class="bottom_btn">
					<van-button type="primary" @click="loginIn" :style="{background: loginBackground}">登录</van-button>
				</div>
				<p class="explain">用户登录即注册</p>
				<!-- <div class="ad_urls">
					<img :src="adUrl">
				</div> -->
			</section>
			<section v-else-if="type=='yinsi'">
				<div></div>
				<van-nav-bar title="隐私协议" :left-arrow="!topLeftArrow" @click-left="lookFn('login')" />
				<div class="close_icon" @click="closeModel" v-if="topLeftArrow">
					<van-icon name="cross" />
				</div>
				<Agreements type="yinsi" />
			</section>
			<section v-else-if="type=='yonghu'">
				<van-nav-bar title="服务协议" :left-arrow="!topLeftArrow" @click-left="lookFn('login')" />
				<div class="close_icon" @click="closeModel" v-if="topLeftArrow">
					<van-icon name="cross" />
				</div>
				<Agreements type="yonghu" />
			</section>
			<section v-else-if="type=='kehu'">
				<van-nav-bar title="展业经理公约" :left-arrow="!topLeftArrow" @click-left="lookFn('login')" />
				<div class="close_icon" @click="closeModel" v-if="topLeftArrow">
					<van-icon name="cross" />
				</div>
				<Agreements type="kehu" />
			</section>
		</van-popup>
	</section>
</template>

<script>
import Agreements from "components/Agreements"
import LoginServer from "api/login"

export default {
    name: "login",
	props: {
		isLoginModel: Boolean,
		type: String,
		topLeftArrow: Boolean
		
	},
	components: {
		Agreements
	},
	watch:{
		isAgree(val, old) {
			if(val&&this.params.phone&&this.params.smsCaptcha) {
				this.loginBackground = "#3A5EEC"
			}else {
				this.loginBackground = "#D2D8E9"
			}
		}
	}, 
    data() {
		//type: login, yinsi, yonghu, kehu
        return {
			value: '',
			isAgree: 0,
			isCode: 0,
			isSend: false,
			time: 60000,
			params: {
				phone: '',
				systemId: 1,
				smsCaptcha: '',
				siteId: 3,
				deviceType: '', //"IOS","ANDROID","H5","WEB" 平台类型	
				market: '',	//"IOS","ANDROID","HUAWEI","OPPO","VIVO","XIAOMI","OSS","YYB","APPSTORE","WEB" 市场
				versionNumber: this.$store.state.versionData.versionNumber				
			},
			loginBackground: "#D2D8E9",
			adUrl: 'https://oss.kkqd.vip/baiboss/2022119/pku5j1609e/sd_login_ad_banner.png',
			flag: true,
		};
		
    },
    created() {
		this.getPlatform()
	},
    methods: {
		getCode() {
			if(!this.isCode && !this.isSend) return
			let params = {
				captchaNode: "sms_sd_captcha",
				phone: this.params.phone,
				systemId: this.params.systemId,
			}
			LoginServer.SendCode(params).then((res) => {
				if(res.code ==1) {
					this.isSend = true
				}
				this.smsCaptcha = res.data
			})
		},
		loginIn() {
			if(!this.isAgree) return
			if(!this.flag) return
			this.flag = false
			if(this.$store.state.clientType == 2) {
				this.params.deviceType = this.$store.state.deviceType
				this.params.market = this.$store.state.market
			}
			LoginServer.Login(this.params).then((res) => {
				localStorage.setItem('token', res.data.token)
				this.$emit("loginStatus", "ok", res.data.newUser)
			}).catch(() => {
				this.flag = true
			})
		},
		agreeFn() {
			if(this.isAgree) {
				this.isAgree = 0
			}else {
				this.isAgree = 1
			}
			
		},
		checkMobile(str) {
			var re = /^(?:(?:\+|00)86)?1\d{10}$/
			if (re.test(str)) {
				return true
			} else {
				return false
			}
		},
		changePhone() {
			if(this.checkMobile(this.params.phone)) {
				this.isCode = 1
				if(this.isAgree&&this.params.phone&&this.params.smsCaptcha) {
					this.loginBackground = "#3A5EEC"
				}
			}else {
				this.isCode = 0
				this.loginBackground="#D2D8E9"
			}
		},
		changeCode() {
			if(this.isAgree&&this.params.phone&&this.params.smsCaptcha) {
				this.loginBackground = "#3A5EEC"
			}else {
				this.loginBackground="#D2D8E9"
			}
		},
		lookFn(type) {
			this.$emit("loginModelFn", type)
		},
		timeFinish() {
			this.isSend = false
		},
		closeModel() {
			this.$emit('closeModel')
		},
		skipTicket() {
			this.$router.push({ name: 'ticket-get'})
		},


		//h5的渠道
		getPlatform() {
			let u = navigator.userAgent,
				type = '';
			if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
				type = "ANDROID"
			} else if (u.indexOf('iPhone') > -1 || u.indexOf('iPad') > -1) {
				type = "IOS"
			} else  {
				type = "WEB"
			}
			if(type!="WEB") {
				this.params.deviceType = "H5"
				this.params.market = type
				
			}else {
				this.params.deviceType = "WEB"
				this.params.market = "WEB"
			}
		}
	},
};
</script>

<style lang="scss">
.login {
	.van-hairline--bottom {
		position: fixed;
		width: 100%;
		border-bottom: 1px solid #f6f6f6;
		border-top-left-radius: 30px;
		border-top-right-radius: 30px;
	}
	.ad_urls {
		position: relative;
		z-index: 2;
		padding: 42px 29px;
		padding-bottom: 0;
		background: #fff;
		img {
			width: 100%;
			border-radius: 4px;
		}
	}
	.login_model {
		// position: relative;
		.close_icon {
			position: fixed;
			// top: 0;
			left: 0;
    		z-index: 20;
			height: 59px;
			line-height: 59px;
			color: #7D8290;
			font-size: 22px;
			i {
				padding: 20px 18px;
				padding-bottom: 0;
			}
		}
		.login_icon {
			text-align: center;
			padding-top: 120px;
			padding-bottom: 20px;
			img {
				width: 96px;
			}
		}
		.form {
			padding-bottom: 20px;
			padding: 0 29px;
			.van-field {
				border-bottom: 1Px solid #f6f6f6;
			}
			.van-field__control {
				font-size: 16px;
				color: #2B2F3A;
			}
			.van-cell {
				padding: 0;
				height: 68px;
				line-height: 68px;
				padding-top: 10px;
				
			}
			.van-cell::after {
				// border-bottom: 1Px solid #f6f6f6
				// top: 0;
				bottom: -10PX;
			}
			.code {
				color: #a2a6ae;
				font-size: 16px;
			}
			.code_a {
				color: #3A5EEC;
			}
		}
		.desc {
			padding: 0 29px;
			padding-left: 50px;
			position: relative;
			margin-top: 18px;
			div	{
				position: absolute;
				top: 0;
				left: 0;
				width: 45px;
				height: 30px;
			}
			img {
				position: absolute;
				top: 2px;
				left: 30px;
				width: 14px;
			}
			p {
				font-size: 13px;
				color: #A2A6AE;
				span {
					color: #2B2F3A;
				}
			}
		}
		.bottom_btn{
			padding: 0 30px;
			padding-top: 26px;
			.van-button--primary {
				width: 100%;
				height: 42px;
				border-radius: 4px;
				border: 0;
				font-size: 15px;
				font-weight: bold;
				color: #FFFFFF;
			}
		}
		.explain {
			color: #A2A6AE;
			font-size: 13px;
			padding-top: 14px;
			text-align: center;
		}
		.van-nav-bar__title {
			color: #2B2F3A;
			font-size: 17px;
		}
		.van-nav-bar__content {
			height: 59px;
		}
		.van-nav-bar__left {
			.van-icon-arrow-left {
				color: #979797;
				font-size: 22px;
			}
		}
		.van-count-down {
			display: inline-block;
			color: #A2A6AE;
			font-size: 16px;
		}
		.fix_top {
			// position: absolute;
			// top: 0;
			// left: 0;
			// width: 100%;
			// z-index: 99;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/views/components/Login.vue